news11.vue<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌, ‘완성형 에듀테크 클러스터’ 조성에 박차</h4>
                            <div class="board_meta">
<!--                                <ul>-->
<!--                                    <li>등록일 : 22.05.24</li>-->
<!--                                    <li>조회수 : 142</li>-->
<!--                                </ul>-->
                            </div>
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                              <h2>에듀윌, ‘완성형 에듀테크 클러스터’ 조성에 박차</h2>
                              <p>&nbsp;</p>
                              <ul>
                                <li>- 지난 27일, 티맥스에듀에이아이와 맞손...AI 기반 학습 플랫폼 구축 발판<br>- ‘완성형 에듀테크 클러스터’ 위해 독자적 기술력 보유한
                                  기업들과의 협업 강화<br>&nbsp;
                                </li>
                              </ul>
                              <figure class="image"><img src="//company.eduwill.net/contents/img/20250131164717.JPG"></figure>
                              <p>△사진 설명: 에듀윌 양형남 대표(좌)와 티맥스에듀에이아이 김화중 대표(우)가 27일, 티맥스에듀에이아이 본사에서 업무협약을 체결하고, 기념촬영을 하고
                                있다.</p>
                              <p>&nbsp;</p>
                              <p>(2024-08-29) 에듀윌이 완성형 에듀테크 클러스터 조성을 위해 독자적 기술력을 보유한 기업들과 전략적 MOU를 체결, 자격증 콘텐츠 부문 에듀테크
                                리딩 기업으로의 입지를 다져 나간다.</p>
                              <p>&nbsp;</p>
                              <p>종합교육기업 에듀윌(대표 양형남)은 지난 27일, 티맥스에듀에이아이 본사에서 클라우드 인프라 및 대규모 데이터 분석 시스템 구축을 위해
                                티맥스에듀에이아이(TmaxEduAI, 대표 김화중)와 업무 협약(MOU)를 체결했다고 29일 밝혔다.</p>
                              <p>&nbsp;</p>
                              <p>티맥스에듀에이아이는 AI 기반 지능형 교육 솔루션을 제공하는 기업으로, 학습자의 학습 효율성과 경험을 극대화하는 다양한 원천 기술이 적용된 학습?교육?지식
                                플랫폼을 보유하고 있다.</p>
                              <p>&nbsp;</p>
                              <p>에듀윌은 클라우드 기반의 학습 플랫폼을 구축해 학습자의 행동 데이터를 대규모로 수집·분석하고, 이를 바탕으로 학습자의 학습 동향을 파악해 새로운 교육 콘텐츠
                                개발에 활용할 계획이다.</p>
                              <p>&nbsp;</p>
                              <p>특히 e-Book 기반의 학습 환경을 조성하고, AI 헬프봇과 고객 서비스 자동화를 도입해 운영 효율성을 극대화할 예정이다. 티맥스에듀에이아이의 기술력을
                                활용해 학습자의 개별 학습 패턴을 분석, 맞춤형 학습 루틴과 플래너도 제공할 방침이다.</p>
                              <p>&nbsp;</p>
                              <p>에듀윌은 기술 인프라 강화와 AI 기반 학습 플랫폼 구축을 위해 ㈜산타와 티맥스에듀에이아이와의 협약을 시작으로 에듀테크 클러스터 조성에 박차를 가할
                                계획이다. 향후 △하이브리드 학습환경 구축 △자체 에듀테크 솔루션 개발 △데이터 보안 및 프라이버시 강화 등을 통해 완성형 에듀테크 클러스터를 단계적으로
                                구축해 나간다는 전략이다.</p>
                              <p>&nbsp;</p>
                              <p>에듀윌 양형남 대표는 “AI 기반 학습 서비스는 학습자들에게 최적의 교육 환경을 제공하기 위한 필수적인 요소로, 이번 협약을 통해 에듀윌의 학습 플랫폼이
                                한층 진화할 것으로 기대한다”며 “완성형 에듀테크 클러스터를 조성하는 것은 교육산업의 혁신을 선도하는데 중요한 발판이 되는 만큼 독자적인 기술력을 보유한
                                기업들과 지속적인 협업을 이어 나갈 것”이라고 밝혔다.</p>
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news16" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌, EBS미디어, 메이트아이, 액티부키, 동남아시아 시장 진출 위한 공동 MOU 체결</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                              <!-- 다음 보도 기사가 있을 경우 -->
                              <li class="next">
                                <router-link to="/edu/newsRelease/promotionVideo/news14" data-value="315283">
                                  <strong>다음</strong>
                                  <span>에듀윌, (주)산타와 손잡고 에듀테크 속도 낸다</span>
                                </router-link>
                              </li>
                              <!-- //다음 보도 기사가 있을 경우 -->

                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
